import { OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
var ConstantSelector = /** @class */ (function () {
    function ConstantSelector() {
        this._defaultOptions = [];
        this.formControl = new FormControl('');
        this.options = this._defaultOptions;
        this.propagateChange = function (value) { return ({}); };
    }
    Object.defineProperty(ConstantSelector.prototype, "value", {
        get: function () {
            return this.formControl.value;
        },
        enumerable: true,
        configurable: true
    });
    ConstantSelector.prototype.writeValue = function (value) {
        this.formControl.setValue(value);
    };
    ConstantSelector.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    ConstantSelector.prototype.ngOnChanges = function (inputs) {
        this.propagateChange(this.formControl.value);
    };
    ConstantSelector.prototype.registerOnTouched = function () {
        // lint
    };
    return ConstantSelector;
}());
export { ConstantSelector };
